module.exports = __webpack_public_path__ + "img/gd.319553f.svg";